import { z } from 'zod';
import type { DataHealthEnvelope } from './dataHealth.js';

export const LONG_DATA_JOB_SCHEMA = 'marsmen.long-data-job.v1' as const;
export const LONG_DATA_JOB_LIMITS = { maxRows: 10000, maxBytes: 8 * 1024 * 1024, chunkBytes: 200000,
  pageRows: 1000, maxChunks: 512, pageEnvelopeBytes: 2 * 1024 * 1024, transactionEnvelopeBytes: 3 * 1024 * 1024,
  itemEnvelopeBytes: 350 * 1024, lifetimeSeconds: 7 * 86400, collectionSeconds: 24 * 3600, maxActive: 5 } as const;
export const longDataJobIdSchema = z.string().uuid();
export const longDataJobCreateSchema = z.object({ queryExecutionId: z.string().min(1).max(128) }).strict();
export type LongDataJobStatus = 'queued' | 'collecting' | 'ready' | 'failed' | 'cancelled' | 'expired' | 'revoked';
export type LongDataJob = {
  schema: typeof LONG_DATA_JOB_SCHEMA;
  id: string;
  status: LongDataJobStatus;
  message: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  path: string;
  queryExecutionId: string;
  sources: string[];
  coverage: { returnedRows: number; totalRows: number | null; truncated: boolean; reason: string | null };
  dataHealth: DataHealthEnvelope | null;
  download: { available: boolean; path: string | null; format: 'csv'; nullRepresentation: string };
  chart: { path: string; id: string; revision: string } | null;
  notification: 'none' | 'pending' | 'posting' | 'unknown' | 'delivered' | 'suppressed';
};
export const longDataJobPath = (id: string) => `/data/jobs/${longDataJobIdSchema.parse(id)}`;
export const longDataJobDownloadPath = (id: string) => `/api/data-explorer/jobs/${longDataJobIdSchema.parse(id)}/download.csv`;
export const LONG_DATA_JOB_COLLECTING_MESSAGE = 'Data is being collected. I will reply here with a link or download when it is ready.';
